import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Tabs } from '../../../../1031-exchange/1031-dashboard/1031-dashboard.component';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { IPropertyDetails } from '../../../../shared/models/propertydetails';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { ValidationService } from '../../../../shared/providers/validation.service';
enum MarkettingTabs {
  Dashboard = 1,
  Prospects = 2,
  Files = 3,
  Contacts = 4,
 }

@Component({
  selector: 'app-portfolio-marketting',
  templateUrl: './portfolio-marketting.component.html',
  styleUrls: ['./portfolio-marketting.component.css']
})
export class PortfolioMarkettingComponent implements OnInit {

  constructor(public _authenticationService: AuthenticationService,
    private _propertyService: PropertyListingService, private router: Router, public Validation: ValidationService, private activatedRoute: ActivatedRoute, private loader: LoaderService,) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['markettab'] !== undefined && params['markettab'] !== null && params['markettab'] !== '') {
        this.dashboardActiveTab = params['markettab'];
      }
      });
  }
  user: any;
  @Input() propertyId: number = 0;
  @Input() property= {} as IPropertyDetails;
  @Input() offerstatusid: number = 0;
  @Input() isDashboardEnabled: boolean;
  @Input() UserGuid: string = '0000';
  markettingTab = MarkettingTabs;
  dashboardActiveTab = MarkettingTabs.Dashboard;
  prospectTabVisibility = false as boolean;
  dashboardTabVisibility = false as boolean;
  propertydata: any;
  propsectMennuId: number;
  @Output() viewPlaceOffer = new EventEmitter();
  isFromPortfolio: boolean = true;

  ngOnInit() {
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000';
    this.user = this._authenticationService.user as any;
    if (this.isDashboardEnabled && (this._authenticationService.Admin() || this._authenticationService.SuperAdmin())) {
      this.prospectTabVisibility = true;
      this.dashboardTabVisibility = true;
      this.isFromPortfolio = false;
    }

    if (this.isDashboardEnabled) {
      this.loader.display(true);
      if (this.property != null && this.property.Id > 0) {
        this._propertyService.getPropertyDetails(this.property.Guid, this.user.Id, false, true).subscribe(response => {
          if (response != null && !response.IsAccessDenied && !response.IsPropertyExist) {
            this.prospectTabVisibility = (this._authenticationService.Broker() && this.property.BrokersId.includes(this.user.Id))
              || this._authenticationService.Admin()
              || this._authenticationService.SuperAdmin()
              || (this.property.ShowProspectToSeller && this.property.SellerId.includes(this.user.Id));

            this.dashboardTabVisibility = (this._authenticationService.Broker() && this.property.BrokersId.includes(this.user.Id))
              || this._authenticationService.Admin()
              || this._authenticationService.SuperAdmin()
              || (this.property.PropertyStatus != 'Off-Market' && this.property.SellerId.includes(this.user.Id));

            if (this.prospectTabVisibility) {
              this.isFromPortfolio = false;
            }

            this.propertydata = response;
            this.offerstatusid = this.propertydata.OfferStatusId;
          }
          this.loader.display(false);
        });
      }
      else {
        this.prospectTabVisibility = (this._authenticationService.Broker() && this.property.BrokersId.includes(this.user.Id))
          || this._authenticationService.Admin()
          || this._authenticationService.SuperAdmin()
          || (this.property.ShowProspectToSeller && this.property.SellerId.includes(this.user.Id));

        this.dashboardTabVisibility = (this._authenticationService.Broker() && this.property.BrokersId.includes(this.user.Id))
          || this._authenticationService.Admin()
          || this._authenticationService.SuperAdmin()
          || (this.property.PropertyStatus != 'Off-Market' && this.property.SellerId.includes(this.user.Id));

        if (this.prospectTabVisibility) {
          this.isFromPortfolio = false;
        }

        this.propertydata = this.property;
        this.offerstatusid = this.propertydata.OfferStatusId;
        this.loader.display(false);
      }
      
    }
  }

  onDashboardTabClick(tab) {
    this.dashboardActiveTab = tab;
    this.propsectMennuId = -1;
    if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
      localStorage.removeItem('currentFileRefreshTab');
    }
    if (tab == MarkettingTabs.Dashboard || tab == MarkettingTabs.Prospects) {
     
    }

    //let url = this.router.url.split('?')[0];
    //url = this.Validation.updateQueryStringParameter(this.router.url, 'markettab', tab)
    //this.router.navigateByUrl(url);
  }

  loadProspect(type: any) {
    this.propsectMennuId = type.id;
    this.dashboardActiveTab = MarkettingTabs.Prospects;
  }
  showPlaceOffer(offerVisiblity) {
    this.viewPlaceOffer.emit(offerVisiblity);
  }

}
